module.exports = __webpack_public_path__ + "static/media/interests.8b748e55.jpg";